import Cart from '../types/Cart';

export function cartContainsGifts(cart: Cart) {
    return cart.lines.edges.some((edge) =>
        edge.node.attributes.some(
            (attr) => attr.key === 'gift' && attr.value === 'true'
        )
    );
}
